import { flatten } from "lodash"
import type { EpicDependencies } from "../../../rxjs/configureEpics"
import { getHttpHeaders } from "../../../auth/selectors"
import type { PaymentsSettingsSaveRequest } from "../../../../graphql/types"
import { downloadReportFailure } from "../../reports/actions"
import { CASH_PAYMENT_SETTINGS_FORM_SUBMITTED, updateSettingRequested } from "../actions"
import { getSelectedTerminalIds, getTerminalIdsWithLocationId } from "../selectors"
import { savePaymentSettingsMutation } from "./request"
import { logger } from "../../../../utils/loggerWrap"
import { defer, Observable, of } from "rxjs"
import { catchError, switchMap } from "rxjs/operators"
import { ofType, StateObservable } from "redux-observable"
import { Action, StateObject } from "../../../redux/types"
import { constructAuditData } from "../../auditLog/utils/utils-payload-data"

export const cashPaymentSettingsFormSubmittedEpics = (
    actions$: Observable<Action>,
    state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(CASH_PAYMENT_SETTINGS_FORM_SUBMITTED),
        switchMap((action: Action) => {
            const locationTerminalIds = getTerminalIdsWithLocationId(
                deps.getState(),
                getSelectedTerminalIds(deps.getState())
            )
            const payload = action.payload.data

            logger.info("cashPaymentSettingsFormSubmittedEpics - form submitted", {
                data: action.payload,
                locationTerminalIds: locationTerminalIds,
            })

            const auditData = constructAuditData(deps, true)

            const data: PaymentsSettingsSaveRequest = {
                locationTerminalIds: locationTerminalIds,
                cashPaymentSettings: {
                    cashPaymentsEnabled: payload.PAYMENT_TYPES_CASH_ENABLED,
                    orderListOptionsEnabled: payload.CASH_TRANSACTIONS_ORDER_LIST_OPTIONS_ENABLED,
                    defaultCashRegisterBalance: payload.ACCOUNT_BANK_AMOUNT,
                    openCashDrawerUponCardTip: payload.APP_TIP_ADJUST_OPENS_CASH_REGISTER,
                },
                auditData: auditData,
            }
            return defer(() => savePaymentSettingsMutation(getHttpHeaders(deps.getState()), data)).pipe(
                switchMap(() => {
                    const updateSettingsActions = locationTerminalIds.map(l => {
                        return [
                            updateSettingRequested(
                                "PAYMENT_TYPES_CASH_ENABLED",
                                JSON.stringify(payload.PAYMENT_TYPES_CASH_ENABLED),
                                l.locationId,
                                l.terminalId
                            ),
                            updateSettingRequested(
                                "CASH_TRANSACTIONS_ORDER_LIST_OPTIONS_ENABLED",
                                JSON.stringify(payload.CASH_TRANSACTIONS_ORDER_LIST_OPTIONS_ENABLED),
                                l.locationId,
                                l.terminalId
                            ),
                            updateSettingRequested(
                                "APP_TIP_ADJUST_OPENS_CASH_REGISTER",
                                JSON.stringify(payload.APP_TIP_ADJUST_OPENS_CASH_REGISTER),
                                l.locationId,
                                l.terminalId
                            ),
                            updateSettingRequested(
                                "ACCOUNT_BANK_AMOUNT",
                                payload.ACCOUNT_BANK_AMOUNT,
                                l.locationId,
                                l.terminalId
                            ),
                        ]
                    })
                    return flatten(updateSettingsActions)
                }),
                catchError(error => of(downloadReportFailure(error)))
            )
        })
    )
export default [cashPaymentSettingsFormSubmittedEpics]
